import { PrimaryMarket_IPO, PrimaryMarket_IPO_ADD_MSG, PrimaryMarket_IPO_CLEAR_MSG, PrimaryMarket_IPO_ERROR, PrimaryMarket_IPO_HIDE_ERROR, PrimaryMarket_IPO_START_LOADER, PrimaryMarket_IPO_STOP_LOADER, } from "../interface/iPrimaryMarketIpo";
const initState = {
    data: {
        OngoingIPO: [],
        UpcomingIPO: [],
        AboutListIPO: [],
        ListedIPO: [],
    },
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
    message: {
        msg: "",
        show: false,
        icon: "",
    },
};
const PrimaryMarketIpoReducer = (state = initState, action) => {
    switch (action.type) {
        case PrimaryMarket_IPO:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case PrimaryMarket_IPO_ADD_MSG:
            return Object.assign(Object.assign({}, state), { message: action.payload.message });
        case PrimaryMarket_IPO_CLEAR_MSG:
            return Object.assign(Object.assign({}, state), { message: initState.message });
        case PrimaryMarket_IPO_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case PrimaryMarket_IPO_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case PrimaryMarket_IPO_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case PrimaryMarket_IPO_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default PrimaryMarketIpoReducer;
